<template>
	
	    <v-dialog
            v-model="is_auto_sync_dialog_fourth_open"
            width="500" persistent>
            <v-card
			    class="secure-modal proceed-modal csv-file-modal"
			    max-width="500"
          persistent
			  >
			    <v-card-title class="text-h5  ">
					<v-card-actions class="close-icon">
						<v-btn color="primary" text @click="closeDialogfourth()">
						   <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
						</v-btn>
					</v-card-actions>
				</v-card-title>
			    
			    <v-container fluid>
				 <v-card-title><h5>{{titleInfo}}</h5></v-card-title><br>

			      <v-row dense>
			        <v-col
			          v-for="card in cards"
			          :key="card.title"
			          :cols="card.flex"
			        >
			          <v-card style="border: 2px solid #F19700; border-radius:10px !important; background-color:#FFF3E0;" v-if="card.title=='Gmail'" @click="proceedAutoTrackDialogFifth()">
			            <v-img :src="card.src" class="align-end" height="60px">
			            </v-img>
			            <v-card-title class="text-white" v-text="card.title" style="text-align:bottom !important"></v-card-title>
			          </v-card>
			          <v-card style="border: 2px solid #F19700; border-radius:10px !important;" title="Coming Soon !" v-else>
			            <v-img :src="card.src" class="align-end" height="60px">
			            </v-img>
			            <v-card-title class="text-white" v-text="card.title" style="text-align:bottom !important"></v-card-title>
			          </v-card>
			        </v-col>
			      </v-row>
			      <v-row style="color:#1A407D;">Currently Auto Track is available with Gmail only. We are working to make live with other emails soon.</v-row>
			    </v-container>
			  </v-card>
	</v-dialog>
</template>	
<script>
    import { Auth } from "aws-amplify";
    import Datepicker from 'vuejs-datepicker';
    export default {
 		components: {
		  Datepicker,
		},
	  	props: ['is_auto_sync_dialog_fourth_open_status', 'get_auto_sync_dialog_fourth_data', 'getDashboardType'],
	  	data: function () {
		    return { 
			   	is_auto_sync_dialog_fourth_open:this.is_auto_sync_dialog_fourth_open_status,
          delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
          cards: [
			   
			        { title: 'Gmail', src: 'https://dev-api.nimeya.ai/img/icons/gmail.png', flex: 6, bg:'#FFF3E0' },
			        { title: 'Yahoo', src: 'https://dev-api.nimeya.ai/img/icons/yahoo.png', flex: 6 },
			        { title: 'Outlook', src: 'https://dev-api.nimeya.ai/img/icons/outlook.png', flex: 6 },
			        { title: 'Zoho', src: 'https://dev-api.nimeya.ai/img/icons/zoho.png', flex: 6 },
			        { title: 'Hotmail', src: 'https://dev-api.nimeya.ai/img/icons/hotmail.png', flex: 6 },

			    ],

			    titleInfo:'Select the email where the eCAS statement is received for the member',
		    }
		},

		mounted (){
			 if(this.getDashboardType =='retirement'){
          this.titleInfo = 'Select the email where the CRA statement is received for the member';
			 }
			 else{
          this.titleInfo = 'Select the email where the eCAS statement is received for the member';
			 }
		},	

		methods:{
			proceedAutoTrackDialogFifth(){
                this.$emit('allowAutoSyncDialogFifth', true); 
			},

			closeDialogfourth(status){
				this.$emit('allowAutoSyncDialogFifth', false); 
			}
		}
	}	
</script>
<style scoped>
  .tex_color{
  	  color: #0144AF !import;
  }

  .secure-modal .v-card__title {
  	 border-bottom: none !important;
  }
</style>    	